import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.scss';
import '../src/scss/app.scss';
import App from './App';
import ErrorBoundary from './js/components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import "react-datepicker/dist/react-datepicker.css";

const root = ReactDOM.createRoot(document.getElementById('main'));
const appMode = { mode: 'web' };

root.render(
  <ErrorBoundary>
    <App appMode={appMode.mode} />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
